<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <modal-default v-bind:title="title" v-bind:size="size" ref="thisModal" v-bind:onsave="doSave">

      <div class="container-fluid pb-3">

        <div class="row" v-show="false">
          <div class="col-1">
            <input-checkbox id="OverRidable" @input="setOverride" v-bind:checked="property.OverRidable == true"></input-checkbox>
          </div>
          <div class="col-11">
            <span v-if="property.ElementType == 0">
              {{ $t('property_enable_user_upload') }}

            </span>
            <span v-if="property.ElementType != 0">
              {{ $t('property_override_parent_item') }}
            </span>
          </div>
        </div>
        <div class="row mt-3" v-show="property.ElementType != 9">
          <div class="col-1">
            <input-checkbox id="Required" @input="setRequired" v-bind:checked="property.Required == true"></input-checkbox>
          </div>
          <div class="col-11">
            <span>
              {{ $t('required') }}
            </span>
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType == 5 || property.ElementType == 16">
          <div class="col-1">
            <input-checkbox id="EnableMultiple" @input="setEnableMultiple" v-bind:checked="property.EnableMultiple == true"></input-checkbox>
          </div>
          <div class="col-11">
            <span v-if="property.ElementType == 0">
              {{ $t('property_enable_multiple_uploads') }}
            </span>
            <span v-if="property.ElementType != 0">
              {{ $t('property_enable_multiple_items') }}
            </span>
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType == 5 || property.ElementType == 16">
          <div class="col-1">
            <input-checkbox id="ForceCamera" name="ForceCamera" @input="toggleSettingsValue" v-bind:checked="property.Settings != null && property.Settings.Property != null && property.Settings.Property.ForceCamera == 'true'"></input-checkbox>
          </div>
          <div class="col-11">
            <span v-if="property.ElementType == 0">
              {{ $t('force_camera') }}
            </span>
            <span v-if="property.ElementType != 0">
              {{ $t('force_camera') }}
            </span>
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType == 5 || property.ElementType == 16">
          <div class="col-1">
            <input-checkbox id="ForceRecent" name="ForceRecent" @input="toggleSettingsValue" v-bind:checked="property.Settings != null && property.Settings.Property != null && property.Settings.Property.ForceRecent == 'true'"></input-checkbox>
          </div>
          <div class="col-11">
            <span v-if="property.ElementType == 0">
              {{ $t('force_recent') }}
            </span>
            <span v-if="property.ElementType != 0">
              {{ $t('force_recent') }}
            </span>
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType == 14">

          <div class="col-12 mt-1">
            ResourceId
          </div>
          <div class="col-12 mt-1">
            <select class="form-control" v-model="resourceId">
              <option value="" style="">{{ $t('select_resource') }}</option>
              <option v-for="resource in resources" v-bind:value="resource.Id">
                {{ resource.Name }}
              </option>
            </select>
          </div>
          <!--<div class="col-12 mt-1">
            <input class="form-control m-0" type="text" v-model="resourceId" />
          </div>-->
        </div>

        <div class="row" style="display:none">
          We should probably remove this.. does not gove so much information to the user
          <div class="col-12" v-if="property.Overridden == true">
            {{ $t('property_this_property_is_overridden') }}
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType == 0">
          <div class="col-1">
            <input-checkbox id="IncludeInProcedure" name="IncludeInProcedure" @input="toggleSettingsValue" v-bind:checked="property.Settings != null && property.Settings.Property != null && property.Settings.Property.IncludeInProcedure == 'true'"></input-checkbox>
          </div>
          <div class="col-11">
            <span>
              {{ $store.translate('property_include_image') }}
            </span>
          </div>

        </div>
        <div class="row mt-3" v-if="property.ElementType == 0 && property.Settings != null && property.Settings.Property != null && property.Settings.Property.IncludeInProcedure == 'true'">
          <div class="col-12 mt-3">
            Image settings
          </div>
          <div class="col-12 mt-1">
            Caption
          </div>
          <div class="col-12 mt-1">
            <input class="form-control m-0" type="text" v-model="imageCaption" />
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType != 9">
          <div class="col-12">
            <div class="custom-control custom-checkbox custom-control-inline">
              <input class="custom-control-input chk-task-success" v-bind:name="'IsHidden_' + '_' + property.Id" v-model="property.InitialHidden" v-bind:key="'IsHidden' + '_' + property.Id" v-bind:id="'IsHidden' + '_' + property.Id" type="checkbox" />
              <label class="custom-control-label chk-task-success" v-bind:for="'IsHidden' + '_' + property.Id">
                {{ $store.translate('hidden') }}
              </label>
            </div>
          </div>
        </div>

        <div class="row mt-3" v-show="property.ElementType == 6 || property.ElementType == 5 || property.ElementType == 16 || property.ElementType == 7 || property.ElementType == 8">
          <div class="col-12 pb-1">
            {{$t('user_permission_level')}}
          </div>
          <div class="col-12 mt-1">
            <select v-bind:id="'select_user_type' +  getId()" class="form-control" @change="userPermissionType">
              <option value="0">{{$t('select')}}</option>
              <option selected value="-1">{{$t('anonymous')}}</option>
              <option value="5">{{$t('administrator')}}</option>
              <option value="1">{{$t('users')}}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3" v-show="property.ElementType == 6">
          <div class="col-12 pb-1">
            {{$t('validation_type')}}
          </div>
          <div class="col-12 mt-1">
            <select v-bind:id="'select_validation_type' +  getId()" class="form-control" @change="validationRegxType">
              <option value="">{{$t('select')}}</option>
              <option value="^\d+$">{{$t('integer')}}</option>
              <option value="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">{{$t('email')}}</option>
              <option value="^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$">{{$t('url')}}</option>
            </select>
          </div>
        </div>

        <div class="row mt-3" v-if="property.ElementType == 8">
          <div class="col-12 pb-1">
            {{$t('manage_options_for_user_select')}}
          </div>
          <div class="col-12 mt-1" v-for="(p, index) in  getSelectItems(property)">
            <div class="row" v-if="index == 0">
              <div class="col-5">
                Text
              </div>
              <div class="col-5">
                Value
              </div>
              <div class="col-2">

              </div>
            </div>
            <div class="row">
              <div class="col-5">
                <input class="form-control" type="text" v-model="p.text" />
              </div>
              <div class="col-5">
                <input class="form-control" type="text" v-model="p.value" />
              </div>
              <div class="col-2">
                <button @click="deleteOption(p, index)" class="btn btn-link">{{$t('delete')}}</button>
              </div>
            </div>


          </div>
          <div class="col-12 mt-1">
            <div class="row">
              <div class="col-5">
                <input class="form-control" type="text" v-model="optionText" v-on:keyup.enter="addOption" />
              </div>
              <div class="col-5">
                <input class="form-control" type="text" v-model="optionValue" v-on:keyup.enter="addOption" />
              </div>
              <div class="col-2">
                <button @click="addOption" class="btn skin primary-button ml-2">{{$t('add')}}</button>
              </div>
            </div>
          </div>
        </div>


        <div class="row mt-3" v-if="property.ElementType == 22">
          <div class="col-12 mt-3">
            Slider settings
          </div>
          <div class="col-12 mt-1">
            Minimum Value
          </div>
          <div class="col-12 mt-1">
            <input class="form-control m-0" type="number" v-model="sliderMinVal" />
          </div>
          <div class="col-12 mt-1">
            Maximum Value
          </div>
          <div class="col-12 mt-1">
            <input class="form-control m-0" type="number" v-model="sliderMaxVal" />
          </div>
          <div class="col-12 mt-1">
            Minimum Value Text
          </div>
          <div class="col-12 mt-1">
            <input class="form-control m-0" type="text" v-model="sliderMinValTxt" />
          </div>
          <div class="col-12 mt-1">
            Maximum Value Text
          </div>
          <div class="col-12 mt-1">
            <input class="form-control m-0" type="text" v-model="sliderMaxValTxt" />
          </div>
          <div class="col-12 mt-1">
            Steps
          </div>
          <div class="col-12 mt-1">
            <input class="form-control m-0" type="number" v-model="sliderSteps" />
          </div>
        </div>

        <div class="row mt-3" v-show="property.ElementType == 21">
          <div class="col-12 mt-3">
            Html Editor
          </div>
          <div class="col-12 mt-1">
            <mce-editor filefolder="News" v-bind:doinit="false" ref="mce" value="" name="description"></mce-editor>
          </div>
        </div>


        <div class="row" v-show="property.ElementType == 9">
          <div class="container-fluid tooBig">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12 mt-0">
                    {{$t('name')}}
                  </div>
                  <div class="col-12 mt-1">
                    <input class="form-control col-12 m-0" type="text" v-model="qrName" style="float: left;margin-left:5px;" />
                  </div>
                  <div class="col-12 mt-0 text-center px-0">
                    <img v-bind:src="qrsource" style="width: 100%;" />
                  </div>
                  <div class="col-12 mt-0" style="margin-top:-10px;">
                    {{$t('description')}}
                  </div>
                  <div class="col-12 mt-1">
                    <input class="form-control col-12 m-0" type="text" v-bind:placeholder="$t('description')" v-model="qrDescription" style="float: left;margin-left:5px;" />
                  </div>

                </div>

              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12 col-6">
                    <div>{{$t('printer')}}:</div>
                    <select class="form-control mt-1" v-model="selectedPrinter" @change="changePrinter">
                      <option value="">{{$t('select_printer')}}</option>
                      <option v-for="p in qrDevices" v-bind:value="p.name">{{p.name}}</option>
                    </select>

                  </div>
                  <div class="col-12 col-6">
                    <div class="mt-3">{{$t('printer_dimensions')}}:</div>
                    <select class="form-control mt-1" v-model="selectedDimension" @change="changeDimensions">
                      <option disabled value="">{{$t('select_dimensions')}}</option>
                      <option v-for="p in qrDimensions" v-bind:value="p.name">{{p.name}}</option>
                    </select>
                  </div>
                  <div class="col-12 col-6 mt-3">
                    <map-button v-bind:text="$t('qr_geofence') + ' '" ref="mapButton" v-bind:latitude="latitude" v-bind:longitude="longitude" @on_map_click="onMapClick"></map-button>
                  </div>
                  <div class="col-12 col-6 mt-3" v-show="property.ElementType == 9">
                    <div class="row">
                      <div class="col-1">
                        <input-checkbox id="Required" @input="setRequired" v-bind:checked="property.Required == true"></input-checkbox>
                      </div>
                      <div class="col-11">
                        <span>
                          {{ $t('required') }}
                        </span>
                      </div>
                    </div>

                  </div>
                  <div class="col-12 col-6 mt-3">
                    <button @click="qrPrint" class="btn skin primary-button">{{$t('print')}}</button>
                  </div>
                  <div class="col-12 mt-1 px-0" v-if="printErrorMessage != ''">
                    <div class="col" style="color: red;">{{printErrorMessage}}</div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>


    </modal-default>
  </div>

</template>

<script>

  var optionValue = "";
  var optionText = "";
  var initialvalue = {
    InitialHidden:false,
    OverRidable: false,
    ElementType:-1,
    EnableMultiple: false,
    Settings: {
      Property: {
        IncludeInProcedure: null
      },
      Items: []
    }
  }

  var editedproperty = JSON.parse(JSON.stringify(initialvalue));

  import MceEditor from "../mce/mce-editor.vue";
  import ModalDefault from "../modals/modal-default.vue";
  import InputCheckbox from "../form-components/input-checkbox.vue";
  import InputText from "../form-components/input-text.vue";
  export default {
    name: "procedure-property-settings",
    components: {
      ModalDefault,
      InputCheckbox,
      InputText,
      MceEditor
    },
    props: {

    },
    data() {
      return {
        optionValue,
        optionText,
        editedproperty,
        initialvalue,
        qrName: '',
        qrDescription: '',
        qrcodeId: -1,
        longitude: 0,
        latitude: 0,
        selectedPrinter: '',
        selectedDimention: null,
        qrDevices: [],
        qrDimensions: [],
        qrWidth: '',
        qrHeight: '',
        qrTemplate: '',
        qrStyle: '',
        qrIsVertical: false,
        title: '',
        printErrorMessage: '',
        size: '',
        imageCaption: '',
        resourceId: '',
        resources: [],
        sliderMinVal: 0,
        sliderMaxVal: 100,
        sliderMinValTxt: '',
        sliderMaxValTxt: '',
        sliderSteps: 1,
      };
    },
    computed: {
      property:
      {
        get() {
          return this.editedproperty;
        },
        set(value) {
          this.editedproperty = value;
        }
      },
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 16");
          this.$store.commit('saveprocedure', value)
        }
      },
      qrsource: {
        get: function () {
          return apiUrl + '/api/Procedures/v1/GetQRCodeById?qrcodeid=' + this.qrcodeId + '&siteId=' + this.$store.getSiteId();
        },
      }

    },
    methods: {
      onMapClick(lat, lng) {
        this.latitude = lat;
        this.longitude = lng;
        this.$refs.mapButton.setMarker(lat, lng)
      },
      qrPrint() {

        if (this.qrTemplate == "") {
          this.printErrorMessage = "Please select print options";
          return;
        }


        var title = this.qrName;
        if (title == "") {
          title = "The title"
        }
        var description = this.qrDescription;
        if (description == "") {
          description = "Some example description, tell your users more.. Sometimes this text could even be three rows"
        }
        var win = window.open('about:blank', "_new");
        win.document.open();

        var css = "<style>";
        css += this.qrStyle;

        // Default styles
        css += ".text-center{";
        css += "text-align:center";
        css += "}";
        css += "body{";
        css += "background-color:#ccc;";
        css += "margin:0px;";
        css += "font-family:arial;";
        css += "}";
        css += ".printercontainer{";
        css += "position:relative;";
        css += "background-color:white;";
        css += "width:" + this.qrWidth + ";";
        css += "max-width:" + this.qrWidth + ";";
        css += "height:" + this.qrHeight + ";";
        css += "max-height:" + this.qrHeight + ";";

        // Rotation or not
        if (this.qrIsVertical == false) {
          css += "-ms-transform:rotate(-90deg);";
          css += "-ms-transform:rotate(-90deg);";
          css += "-webkit-transform: rotate(-90deg)"
          css += "-o-transform:rotate(-90deg);";
          css += "transform: rotate(-90deg); ";
        }
        css += "}";

        // override the prinitn background color
        css += "@media print {";
        css += "body{background-color:initial;}";
        css += "}";

        css += "}";
        css += "</style>";

        var template = this.qrTemplate;
        template = template.replace("{{title}}", title);
        template = template.replace("{{image}}", '<img src="' + this.qrsource + '" />');
        template = template.replace("{{description}}", description)

        win.document.write([
          '<html>',
          '   <head>',
          css,
          '   </head>',
          '   <body>',
          '   <div class="printercontainer">',
          template,
          '   </div>',
          '   </body>',
          '</html>'
        ].join(''));
        win.document.close();
      },
      userPermissionType() {
        this.editedproperty.UserLevel = $("#select_user_type" + this.getId()).val();
        if (this.editedproperty.UserLevel == 0) {
          this.editedproperty.UserLevel = -1;
        }
      },
      validationRegxType() {
        this.editedproperty.ValidationRegx = $("#select_validation_type" + this.getId()).val();
      },
      clearValues() {
        this.imageCaption = "";
        this.resourceId = "";
      },
      getId() {
        return this._uid;
      },
      setOverride(val) {
        if (val == true)
          this.editedproperty.Url = null;
        this.editedproperty.OverRidable = val;
      },
      setRequired(val) {
        this.editedproperty.Required = val;
      },
      setEnableMultiple(val) {
        this.editedproperty.EnableMultiple = val;
      },
      async getQRCode() {
        try {
          this.$http.get('/api/QRCode/v1/BySubtask?subtask=' + this.property.Id).then(async response => {
            var qrcode = response.data;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      saveSliderValues() {
        if (this.sliderMinVal == '') {
          this.sliderMinVal = 0;
        }
        if (this.sliderMaxVal == '') {
          this.sliderMaxVal = 100;
        }
        if (this.sliderSteps == '') {
          this.sliderSteps = 1;
        }
        this.editedproperty.Settings.Property["sliderMinVal"] = this.sliderMinVal;
        this.editedproperty.Settings.Property["sliderMaxVal"] = this.sliderMaxVal;
        this.editedproperty.Settings.Property["sliderMinValTxt"] = this.sliderMinValTxt;
        this.editedproperty.Settings.Property["sliderMaxValTxt"] = this.sliderMaxValTxt;
        this.editedproperty.Settings.Property["sliderSteps"] = this.sliderSteps;
        Vue.set(this, "editedproperty", this.editedproperty)
        this.$forceUpdate();
      },
      saveBookingValues() {
        this.editedproperty.Settings.Property["resourceid"] = this.resourceId;
        Vue.set(this, "editedproperty", this.editedproperty)
        this.$forceUpdate();
      },
      saveImageValues() {
        this.editedproperty.Settings.Property["imagecaption"] = this.imageCaption;
        Vue.set(this, "editedproperty", this.editedproperty)
        this.$forceUpdate();
      },

      saveQrCodeValues() {
        this.editedproperty.Settings.Property["qrcodeid"] = this.qrcodeId;
        this.editedproperty.Settings.Property["qrcodetitle"] = this.qrName;
        this.editedproperty.Settings.Property["qrcodedescription"] = this.qrDescription;
        this.editedproperty.Settings.Property["longitude"] = this.longitude.toString();
        this.editedproperty.Settings.Property["latitude"] = this.latitude.toString();

        Vue.set(this, "editedproperty", this.editedproperty)
        this.$forceUpdate();
      },
      setProperty(element) {

        this.clearValues();

        if (element.ElementType == 9) {
          this.title = this.$t("print_settings");
          this.size = "modal-md";
        }
        else {
          this.title = this.$t("property_settings");
          this.size = "";
        }

        this.editedproperty = JSON.parse(JSON.stringify(initialvalue));
        //console.log(element);
        this.editedproperty = element;
        Vue.set(this, "editedproperty", element)

        if (this.editedproperty !== null && this.editedproperty !== undefined) {
          if (this.editedproperty.ElementType == 6 || this.editedproperty.ElementType == 5 || this.editedproperty.ElementType == 16
            || this.editedproperty.ElementType == 7 || this.editedproperty.ElementType == 8) {
            if (this.editedproperty.UserLevel == undefined) {
              this.editedproperty.UserLevel = -1;
            }
            $("#select_user_type" + this.getId()).val(this.editedproperty.UserLevel);
            $("#select_user_type" + this.getId()).trigger('change');

            $("#select_validation_type" + this.getId()).val(this.editedproperty.ValidationRegx);
            $("#select_validation_type" + this.getId()).trigger('change');
          }

          if (this.editedproperty.ElementType == 0)  {
            if (this.editedproperty.Settings.Property["imagecaption"])
              this.imageCaption = this.editedproperty.Settings.Property["imagecaption"];
          }

          if (this.editedproperty.ElementType == 14) {
            if (this.editedproperty.Settings.Property["resourceid"]) {
              this.resourceId = this.editedproperty.Settings.Property["resourceid"];
            }
            this.loadResources();
          }

          else if (this.editedproperty.ElementType == 9) {
            //this.editedproperty.Required = false;
            var qrCodeid = -1;
            var title = "";
            var description = "";
            var longitude = 0;
            var latitude = 0;

            if (this.editedproperty.Settings.Property["qrcodeid"])
              qrCodeid = this.editedproperty.Settings.Property["qrcodeid"];
            if (this.editedproperty.Settings.Property["qrcodetitle"])
              title = this.editedproperty.Settings.Property["qrcodetitle"];
            if (this.editedproperty.Settings.Property["qrcodedescription"])
              description = this.editedproperty.Settings.Property["qrcodedescription"];

            if (this.editedproperty.Settings.Property["longitude"])
              longitude = parseFloat(this.editedproperty.Settings.Property["longitude"]);

            if (this.editedproperty.Settings.Property["latitude"])
              latitude = parseFloat(this.editedproperty.Settings.Property["latitude"]);

            this.qrcodeId = qrCodeid;
            this.qrName = title;
            this.qrDescription = description;
            this.longitude = longitude;
            this.latitude = latitude;

            if (this.qrName == "")
              this.qrName = element.Text;

            if (this.qrDescription == "")
              this.qrDescription = this.$t("scan_to_mark_as_done");

            this.$refs.mapButton.setMarker(latitude, longitude);
          }

          else if (this.editedproperty.ElementType == 22) {

            if (this.editedproperty.Settings.Property["sliderMinVal"])
              this.sliderMinVal = parseInt(this.editedproperty.Settings.Property["sliderMinVal"]);
            if (this.editedproperty.Settings.Property["sliderMaxVal"])
              this.sliderMaxVal = parseInt(this.editedproperty.Settings.Property["sliderMaxVal"]);
            if (this.editedproperty.Settings.Property["sliderSteps"])
              this.sliderSteps = parseInt(this.editedproperty.Settings.Property["sliderSteps"]);
            if (this.editedproperty.Settings.Property["sliderMinValTxt"])
              this.sliderMinValTxt = this.editedproperty.Settings.Property["sliderMinValTxt"];
            if (this.editedproperty.Settings.Property["sliderMaxValTxt"])
              this.sliderMaxValTxt = this.editedproperty.Settings.Property["sliderMaxValTxt"];

          }
          else if (this.editedproperty.ElementType == 21) {
            this.$refs.mce.setValue('');
            if (this.editedproperty.Settings.Property["htmleditor"])
              this.$refs.mce.setValue(this.editedproperty.Settings.Property["htmleditor"]);
          }
        }
        this.$forceUpdate();
      },
      open() {
        this.$forceUpdate();
        this.$refs.thisModal.open();
      },
      doSave() {
        this.procedure = this.procedure;
        this.$parent.$forceUpdate();
        this.$forceUpdate();


        if (this.editedproperty !== null && this.editedproperty !== undefined) {
          if (this.editedproperty.ElementType == 0) {
            this.saveImageValues();
          }
          if (this.editedproperty.ElementType == 22) {  // slider
            this.saveSliderValues();
          }
          if (this.editedproperty.ElementType == 14) {
            this.saveBookingValues();
          }

          if (this.editedproperty.ElementType == 9) {
            this.saveQrCodeValues();
          }

          if (this.editedproperty.ElementType == 21) {
            //alert(this.editedproperty.Text);
            this.editedproperty.Settings.Property["htmleditor"] = this.$refs.mce.getValue();
          
          }

        }

        this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      setSettingsValue(key, val) {
        this.editedproperty.Settings.Property[key] = val
      },
      toggleHidden() {
        this.InitialHidden = !(this.InitialHidden == true)
      },
      toggleSettingsValue(val, value, key) {
        this.editedproperty.Settings.Property[key] = val.toString();
        Vue.set(this, "editedproperty", this.editedproperty)
        this.$forceUpdate();
      },
      getSelectItems(el) {
        var currentOptions = [];
        if (this.editedproperty.Settings != null && this.editedproperty.Settings.Property["options"]) {
          //currentOptions = this.editedproperty.Settings.Property["options"].split('$|');
          currentOptions = JSON.parse(this.editedproperty.Settings.Property["options"]);
        }
        return currentOptions;
      },
      addOption() {
        var v = { text: this.optionText, value: this.optionValue}
        var currentOptions = [];
        if (this.editedproperty.Settings != null && this.editedproperty.Settings.Property["options"]) {
          currentOptions = JSON.parse(this.editedproperty.Settings.Property["options"]);
        }
        else {
          this.editedproperty.Settings = {
            Property: {
              options: []
            },
            Items: []
          }
        }
        currentOptions.push(v);
        this.editedproperty.Settings.Property["options"] = JSON.stringify(currentOptions);
        this.optionValue = "";
        this.optionText= "";
        this.$forceUpdate();

        /*
        if (this.editedproperty.Settings != null && this.editedproperty.Settings.Property["options"]) {
          currentOptions = this.editedproperty.Settings.Property["options"].split('$|');
        }
        else {
          this.editedproperty.Settings = {
            Property: {
              options: []
            },
            Items: []
          }
        }
        currentOptions.push(v);
        this.editedproperty.Settings.Property["options"] = currentOptions.join('$|');
        this.$forceUpdate();
        */
      },
      deleteOption(v, index) {
        var currentOptions = JSON.parse(this.editedproperty.Settings.Property["options"]);
        currentOptions.splice(index, 1);
        this.editedproperty.Settings.Property["options"] = JSON.stringify(currentOptions);
        this.$forceUpdate();
      },
      selectPrinter() {

      },
      loadDevices() {
        return [{ name: "Standard" }, { name: "Dymo" }]
      },
      loadDimensions(printer) {
        var data = [
          { printer: "Standard", name: "Standard 1 270px X 450px", x: "270px", y: "450px", isvertical: true, template: '<div class="title">{{title}}</div><div class="image">{{image}}</div><div class="description">{{description}}</div>', style: '.title{font-size:30px;padding-top:20px;text-align:center} .description{font-size:20px; padding-left:15px; padding-right:15px;} .image{position:relative;text-align:center} .image img{width:260px;} .printercontainer{width:270px; height:500px}' },
          { printer: "Dymo", name: "Dymo 89x25", x: "89mm", y: "25mm", isvertical: true, template: '<div><div class="title">{{title}}</div><div class="description">{{description}}</div></div><div class="image">{{image}}</div>', style: '.title{position:absolute;top:10;left:10px;px;font-size:20px;} .description{position:absolute;top:38px;left:10px;font-size:12px;width: 225px} .image{position:absolute;top:0px;right:0px;} .image img{width:25mm;} .printercontainer{}' },
          { printer: "Dymo", name: "Dymo 54x25", x: "54mm", y: "25mm", isvertical: true, template: '<div><div class="title">{{title}}</div><div class="description">{{description}}</div></div><div class="image">{{image}}</div>', style: '.title{position:absolute;top:10;left:10px;px;font-size:16px;} .description{position:absolute;top:38px;left:10px;font-size:12px;width: 100px} .image{position:absolute;top:0px;right:0px;} .image img{width:25mm;} .printercontainer{}' },
          { printer: "Dymo", name: "Dymo 54x25 flipped", x: "25mm", y: "54mm", isvertical: false, template: '<div><div class="title">{{title}}</div><div class="description">{{description}}</div></div><div class="image">{{image}}</div>', style: '.title{position:absolute;top:10;left:7px;px;font-size:17px;} .description{position:absolute;top:34px;left:7px;font-size:11px;width: 83px} .image{position:absolute;bottom:0px;right:0px;} .image img{width:25mm;} .printercontainer{margin-top:-55px; margin-left:56px}' },
        ]
        //margin-left: 108px;margin-top: -123px;
        var ret = [];
        for (var i = 0; i < data.length; i++) {
          if (printer == data[i].printer)
            ret.push(data[i]);
        }
        return ret;
      },
      getSelectedDimension() {
        if (this.selectedDimension == "")
          return null;
        var selectedDimension = null;
        var dimensions = this.loadDimensions(this.selectedPrinter);
        for (var i = 0; i < dimensions.length; i++) {
          if (this.selectedDimension == dimensions[i].name)
            selectedDimension = dimensions[i];
        }
        return selectedDimension;
      },
      changePrinter() {
        this.selectedDimension = '';
        this.qrDimensions = this.loadDimensions(this.selectedPrinter);
      },
      changeDimensions() {
        var sel = this.getSelectedDimension();
        if (sel == null) {
          this.qrWidth= '';
          this.qrHeight= '';
          this.qrIsVertical = false;
          this.qrTemplate = '';
          this.qrStyle = '';
          this.printErrorMessage = ""
        }
        else {
          this.qrWidth = sel.x;
          this.qrHeight = sel.y;
          this.qrIsVertical = sel.isvertical;
          this.qrTemplate = sel.template;
          this.qrStyle = sel.style;
          this.printErrorMessage = "";
        }
        this.$forceUpdate();
      },
      async loadResources() {
        try {
          this.$http.get('/api/Bookings/v1/Resources').then(async response => {
            this.resources = [];
            this.resources = response.data;
            Vue.set(this, "resources", this.resources);
          })
        }
        catch (err) {
          alert('some error:' + err)
        }
      }
    },
    mounted() {

    },

    watch: {

    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
      this.qrDevices = this.loadDevices();
      //this.qrDimensions = this.loadDimensions();
    },
  };

</script>

<style scoped>

  .tooBig {
  }

  @media screen and (max-width:768px) {

    .tooBig {
      height: calc(100vh - 160px) !important;
      overflow-y: scroll;
      padding-bottom: 100px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-property-settings.vue